
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.60999 13.7626L7.93498 15.5626C8.23498 15.8626 8.90998 16.0126 9.35998 16.0126H12.21C13.11 16.0126 14.085 15.3376 14.31 14.4376L16.11 8.9626C16.485 7.9126 15.81 7.0126 14.685 7.0126H11.685C11.235 7.0126 10.86 6.6376 10.935 6.1126L11.31 3.7126C11.46 3.0376 11.01 2.2876 10.335 2.0626C9.73498 1.8376 8.98498 2.1376 8.68498 2.5876L5.60999 7.1626","stroke":"currentColor","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M1.78497 13.7625V6.41255C1.78497 5.36255 2.23497 4.98755 3.28497 4.98755H4.03497C5.08497 4.98755 5.53497 5.36255 5.53497 6.41255V13.7625C5.53497 14.8125 5.08497 15.1875 4.03497 15.1875H3.28497C2.23497 15.1875 1.78497 14.8125 1.78497 13.7625Z","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    